import { el, field } from "./dom";

// The drawer's keyboard-calibration dials (white-key width + horizontal offset),
// extracted from controls.ts to keep that glue file under the size cap. Build the
// inputs, expose the drawer rows, and reflect persisted values.

interface CalibrationHandlers {
  onWhiteWidth(px: number): void;
  onOffset(px: number): void;
}

interface CalibrationControls {
  /** Drawer rows to splice into the Calibration section. */
  rows: HTMLElement[];
  /** Reflect persisted calibration into the controls. */
  set(whiteWidthPx: number, offsetPx: number): void;
}

export function buildCalibrationControls(handlers: CalibrationHandlers): CalibrationControls {
  const whiteWidth = el<HTMLInputElement>("input", {
    type: "range",
    min: "30",
    max: "140",
    value: "38",
  });
  whiteWidth.oninput = () => handlers.onWhiteWidth(Number(whiteWidth.value));
  const offset = el<HTMLInputElement>("input", {
    type: "range",
    min: "-1000",
    max: "1000",
    value: "0",
  });
  offset.oninput = () => handlers.onOffset(Number(offset.value));
  return {
    rows: [field("Key width", whiteWidth), field("Offset", offset)],
    set: (whiteWidthPx, offsetPx) => {
      whiteWidth.value = String(whiteWidthPx);
      offset.value = String(offsetPx);
    },
  };
}
